import { Spin as AntdSpin, SpinProps as AntdSpinProps } from "antd";
import {
  LoadingMediumIcon,
  LoadingLargeIcon,
  LoadingExtraLargeIcon,
} from "@/base/static/index";
import { CMP_PREFIX } from "@/base/constant";

export interface SpinProps extends AntdSpinProps {}

export const spinPrefixCls = `${CMP_PREFIX}-spin`;

export const Spin = ({ indicator, size = "default", ...props }: SpinProps) => {
  const getIndicatorIcon = (size: SpinProps["size"]) => {
    const map = {
      default: <LoadingLargeIcon spin />,
      large: <LoadingExtraLargeIcon spin />,
      small: <LoadingMediumIcon spin />,
    };

    return (size && map[size]) || map["default"];
  };

  return (
    <AntdSpin
      size={size}
      indicator={indicator || getIndicatorIcon(size)}
      {...props}
    />
  );
};
